<template>
  <div id="container">
    <div class="box_one" style="margin-bottom:5px"> 
      <cont-top/>
    </div>     
    <div class="box_one" style="margin-bottom:5px"> 
      <cont-one/>
    </div>    
    <div class="box_one" > 
      <cont-bottom/>
    </div>
  </div>
</template>

<script>
import ContTop from '@/views/BrakeComponent/cont_one'
import ContBottom from '@/views/Components/Cont_bottom'
import ContOne from './brakeOilComponents//cont_one'


export default {
  name: 'BrakeDisc',
  components : {
    ContTop ,
    ContBottom ,
    ContOne
  }
}

</script>

<style lang="stylus" scoped>
#container
  background-color : #000
.box 
  width: 100%;
</style>